export default (axios, baseURL) => async (clientSid, userInfo) => {
  const url = `/hub/clients/${encodeURIComponent(clientSid)}/csv/users`;

  const axiosConfig = {
    method: 'POST',
    baseURL,
    url,
    data: { userInfo }
  };

  const axiosResponse = await axios(axiosConfig);

  if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
    throw new Error('Invalid response from gateway');
  }
  return axiosResponse.data;
};
